










import {WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {DataType, Field} from '@/components/DataGrid.vue'
import {datePeriodStartDate, getTodayYYYYMMDD, toYYYYMMDD} from "@/data/sources/dates"
import {executeQuery} from "@/data/repos/query"
import {defineComponent} from "@vue/composition-api"
import DataGridWidget from "@/components/widgets/DataGridWidget.vue"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Table(),
    widget: "AuditActiveAuditsByTeam",
    title: "Active Audits By Team",
    params: {
      auditCategory: {...WParamTpl.auditCategory(), _order: 1},
    },
  }
}

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    DataGridWidget,
  },
  setup(props, context) {
    context.emit("config-update", config())
    const fields: Field[] = [
      {name: 'name', title: 'Name', dataType: DataType.Text, sort: true},
      {name: 'activeAuditCount', title: 'Count', dataType: DataType.Number, sort: true},
    ]

    async function dataFetcher(offset: number, max: number) {
      if (offset !== 0) {
        return []
      }
      const fromDate = toYYYYMMDD(datePeriodStartDate(new Date(), "1y"))
      const toDate = getTodayYYYYMMDD()
      return await executeQuery("micad4-audit", "activeAuditsByTeam",
        {locale: "en-GB", fromDate, toDate, categoryID: props.config && props.config.params.auditCategory.value.value || 0})
    }

    function titleCallback(config: any) {
      return "Category: " + (config.params.auditCategory.value.title || "<All>")
    }

    return {fields, dataFetcher, titleCallback}
  },
})
